import { IPagination } from "@/types";

export class Pagination<T> implements IPagination<T> {
  public current_page = 0;
  public first_page_url = "";
  public from = 0;
  public last_page = 0;
  public last_page_url = "";
  public next_page_url: string | null = "";
  public path = "";
  public per_page = 0;
  public prev_page_url: string | null = "";
  public to = 0;
  public total = 0;
  public data: T[] = [];

  public constructor(props?: IPagination<T>) {
    if (!props) {
      return;
    }
    Object.assign(this, props);
  }
}
